import type { ILanguageResources, ITranslationModule } from '../../../../interfaces';
import { interpolate } from '../../../../global';

class Id {
  private constructor() {}
  public static readonly prefix = 'UI.scripts.dealer-franchisee.franchisee.view.FranchiseePaymentProfilePicker.';
  public static readonly selectPaymentProfile = `${Id.prefix}selectPaymentProfile`;
}

export class LangFranchiseePaymentProfilePicker {
  private constructor() {}
  public static selectPaymentProfile(): string {
    return interpolate(Id.selectPaymentProfile);
  }
}

export class FranchiseePaymentProfilePickerModule implements ITranslationModule {
  registerItems(register: ILanguageResources) {
    register.add(
      Id.selectPaymentProfile,
      "Select a {{glossary 'payment-profile'}}",
      'Dialog title for selecting a payment profile in franchisee payment profile picker'
    );
  }
}
